<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="请输入查询关键字" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasPerm="laborers:attendance-config:save" el-type="success" @click="toEdit({})">新建</page-button>
<!--          <page-button hasPerm="laborers:attendance-config:warn" el-type="warning" @click="goToWarnConfig">打卡预警配置</page-button>-->
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="attendanceConfig">
          <yq-table-column label="配置名称" prop="configName" min-width="180rem"/>
          <yq-table-column label="上班时间" prop="inTime"/>
          <yq-table-column label="下班时间" prop="outTime"/>
          <yq-table-column label="上班打卡时间段" prop="inTimeMin">
            <template v-slot="{row}">
              <span v-if="row.inTimeMin">{{row.inTimeMin.replace("-", "").replace("+", "")}}至{{row.inTimeMax.replace("-", "").replace("+", "")}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="下班打卡时间段" prop="outTimeMim">
            <template v-slot="{row}">
              <span v-if="row.outTimeMin">{{row.outTimeMin.replace("-", "").replace("+", "")}}至{{row.outTimeMax.replace("-", "").replace("+", "")}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="150rem"
                           :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button hasPerm="laborers:attendance-config:save" @click="toEdit(row)">编辑</table-button>
                <table-button hasPerm="laborers:attendance-config:site" @click="toSet(row)">设置工地</table-button>
                <table-button hasPerm="laborers:attendance-config:remove" el-type="danger" message="是否确认删除数据" @click="deleteRow(row.id)">
                  删除
                </table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <el-dialog v-model="showEdit" title="编辑" width="30%" @closed="currentData = {}">
      <form-items :data="currentData" :columns="1" label-width="3.5rem" icon-width="0">
        <form-item label="配置名称" name="configName" :required="true" error-message="请填写配置名称">
          <el-input v-model="currentData.configName" placeholder="请输入配置名称"/>
        </form-item>
        <form-item label="上班时间" name="inTime" :required="true" error-message="请填写上班时间">
          <el-time-picker
              style="width: 100%"
              v-model="currentData.inTime"
              placeholder="请填写上班时间"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
          />
        </form-item>
        <form-item label="下班时间" name="outTime" :required="true" error-message="请填写下班时间">
          <el-time-picker
              style="width: 100%"
              v-model="currentData.outTime"
              placeholder="请填写下班时间"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
          />
        </form-item>
        <form-item label="上班打卡时间段" name="inTimeMin" :required="true" error-message="请设置打卡时间范围，超过范围打卡将不生效">
          <div class="time-limit-container">
            <el-time-picker
                class="time-limit"
                v-model="currentData.inTimeMin"
                placeholder="请填写开始时间"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
            />
            <el-time-picker
                class="time-limit"
                v-model="currentData.inTimeMax"
                placeholder="请填写结束时间"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
            />
          </div>

        </form-item>
        <form-item label="下班打卡时间段" name="outTimeMin" :required="true" error-message="请设置打卡时间范围，超过范围打卡将不生效">
          <div class="time-limit-container">
            <el-time-picker
                class="time-limit"
                v-model="currentData.outTimeMin"
                placeholder="请填写开始时间"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
            />
            <el-time-picker
                class="time-limit"
                v-model="currentData.outTimeMax"
                placeholder="请填写结束时间"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
            />
          </div>

        </form-item>

      </form-items>
      <template #footer>
        <page-button type="read" @click="showEdit = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="save">保存</page-button>
      </template>
    </el-dialog>

    <el-dialog v-model="showSet" title="设置工地" width="50%" @closed="currentConfigId = ''">
      <div class="dialog-content">
        <div class="dialog-header-action">
          <el-button type="primary" @click="showSelectSite = true">
            <el-icon><Plus /></el-icon>
            添加工地
          </el-button>
        </div>
        
        <div class="site-list" v-if="configSiteList && configSiteList.length > 0">
          <div class="site-card" v-for="(site, index) in configSiteList" :key="index">
            <div class="site-info">
              <div class="site-name">
                <el-icon><Location /></el-icon>
                <span>{{ site.siteName }}</span>
              </div>
              <div class="site-leader">
                <el-icon><User /></el-icon>
                <span>{{ site.leaderName || '暂无负责人' }}</span>
              </div>
            </div>
            <div class="site-actions">
              <el-button type="primary" link @click="toEditSiteAttendConfig(site.id)">
                <el-icon><Edit /></el-icon>
                编辑
              </el-button>
            </div>
          </div>
        </div>
        
        <yq-empty v-else description="暂无工地配置" :image-size="100">
          <el-button type="primary" @click="showSelectSite = true">添加工地</el-button>
        </yq-empty>
      </div>
    </el-dialog>

    <el-dialog v-model="showSelectConfig" title="编辑考勤配置" width="30%" @closed="currentData = {}">
      <div class="dialog-content">
        <div class="form-section">
          <div class="form-label">
            <el-icon><Setting /></el-icon>
            <span>考勤配置</span>
            <span class="required-mark">*</span>
          </div>
          <el-select 
            v-model="currentConfigId2" 
            placeholder="请选择考勤配置"
            style="width: 100%"
            clearable
          >
            <el-option 
              v-for="item in configList" 
              :key="item.id" 
              :value="item.id" 
              :label="item.configName"
            >
              <div class="config-option">
                <span>{{ item.configName }}</span>
                <div class="config-time">
                  <span>{{ item.goWorkTime }} - {{ item.backWorkTime }}</span>
                </div>
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
      
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="showSelectConfig = false">取消</el-button>
          <el-button type="primary" @click="saveSiteConfig" :disabled="!currentConfigId2">保存</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog 
      v-model="showSelectSite" 
      title="选择工地" 
      width="70%" 
      @closed="close"
      :close-on-click-modal="false"
      class="select-site-dialog-wrapper"
    >
      <div class="select-site-dialog">
        <!-- 搜索过滤框 -->
        <div class="search-section">
          <el-input
            v-model="searchKeyword"
            placeholder="搜索工地名称或项目名称"
            clearable
            size="large"
          >
            <template #prefix>
              <el-icon><Search /></el-icon>
            </template>
          </el-input>
        </div>

        <!-- 内容区域：左侧列表，右侧预览 -->
        <div class="content-layout">
          <!-- 左侧：工地和项目列表 -->
          <div class="list-section">
            <div class="section-header">
              <div class="header-left">
                <el-icon><List /></el-icon>
                <span class="section-title">可选项</span>
              </div>
              <span class="section-count">共 {{ filteredItems }} 项</span>
            </div>
            
            <div class="items-scroll-container" v-if="filteredItems > 0">
              <div class="items-list">
                <!-- 工地列表 -->
                <div class="items-group" v-if="filteredSites.length > 0">
                  <div class="group-title">
                    <el-icon><LocationFilled /></el-icon>
                    <span>工地（{{ filteredSites.length }}）</span>
                  </div>
                  <div class="items-grid">
                    <div 
                      class="item-card site-item" 
                      v-for="site in filteredSites" 
                      :key="'site-' + site.id"
                      :class="{ 'selected': isSiteSelected(site.id) }"
                      @click="toggleSite(site)"
                    >
                      <div class="item-content">
                        <div class="item-checkbox">
                          <el-checkbox 
                            :model-value="isSiteSelected(site.id)" 
                            @change="() => toggleSite(site)" 
                            @click.stop 
                          />
                        </div>
                        <div class="item-info">
                          <div class="item-name">{{ site.siteName }}</div>
                          <div class="item-detail" v-if="site.leaderName">
                            <el-icon><User /></el-icon>
                            <span>{{ site.leaderName }}</span>
                          </div>
                        </div>
                        <el-tag size="small" type="success" effect="plain">工地</el-tag>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 项目列表 -->
                <div class="items-group" v-if="filteredProjects.length > 0">
                  <div class="group-title">
                    <el-icon><FolderOpened /></el-icon>
                    <span>项目（{{ filteredProjects.length }}）</span>
                  </div>
                  <div class="items-grid">
                    <div 
                      class="item-card project-item" 
                      v-for="project in filteredProjects" 
                      :key="'project-' + project.id"
                      :class="{ 'selected': isProjectSelected(project.id) }"
                      @click="toggleProject(project)"
                    >
                      <div class="item-content">
                        <div class="item-checkbox">
                          <el-checkbox 
                            :model-value="isProjectSelected(project.id)" 
                            @change="() => toggleProject(project)" 
                            @click.stop 
                          />
                        </div>
                        <div class="item-info">
                          <div class="item-name">{{ project.projectName }}</div>
                          <div class="item-detail" v-if="project.leader">
                            <el-icon><User /></el-icon>
                            <span>{{ project.leaderName }}</span>
                          </div>
                        </div>
                        <el-tag size="small" type="primary" effect="plain">项目</el-tag>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="empty-container" v-else>
              <yq-empty description="未找到匹配的工地或项目" :image-size="100" />
            </div>
          </div>

          <!-- 右侧：选中预览 -->
          <div class="preview-section">
            <div class="section-header">
              <div class="header-left">
                <el-icon><View /></el-icon>
                <span class="section-title">已选择预览</span>
              </div>
              <span class="section-count">{{ querySelectSite.length }} 个</span>
            </div>
            
            <div class="preview-scroll-container">
              <div class="preview-list" v-if="querySelectSite && querySelectSite.length > 0">
                <div class="preview-card" v-for="(site, index) in querySelectSite" :key="index">
                  <div class="preview-info">
                    <div class="preview-name">
                      <el-icon><Location /></el-icon>
                      <span>{{ site.siteName }}</span>
                    </div>
                    <div class="preview-leader" v-if="site.leaderName">
                      <el-icon><User /></el-icon>
                      <span>{{ site.leaderName }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <yq-empty v-else description="请从左侧选择工地或项目" :image-size="80" />
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="showSelectSite = false" size="large">取消</el-button>
          <el-button 
            type="primary" 
            @click="saveSiteConfig2" 
            :disabled="querySelectSite.length === 0"
            size="large"
          >
            保存（{{ querySelectSite.length }}个工地）
          </el-button>
      </div>
      </template>
    </el-dialog>

  <laborers-attendance-config-classmate ref="settingClassmate" :config-data="currentConfig" :config-list-all="configList"/>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import {useRoute, useRouter} from "vue-router";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import attendConfigApi from "@/api/dz-luqiao/attendConfigApi";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";
import {Location, User, Edit, Plus, View, Setting, Search, LocationFilled, FolderOpened, List} from '@element-plus/icons-vue';
import LaborersAttendanceConfigClassmate from "@/views/h5/luqiao/laborers/attendance/config/LaborersAttendanceConfigClassmate.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LAC",
  components: {
    FormItem, FormItems,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage,
    Location, User, Edit, Plus, View, Setting, Search, LocationFilled, FolderOpened, List, LaborersAttendanceConfigClassmate
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      showEdit: false,
      currentData: {
        inTime: "",
        outTime: "",
        inTimeMin: "",
        inTimeMax: "",
        outTimeMin: "",
        outTimeMax: "",
      },
      currentConfigId: "",
      currentConfigId2: "",
      currentSiteId: "",
      showSet: false,
      configSiteList: [],
      configList: [],
      showSelectConfig: false,
      siteList: [],
      showSelectSite: false,
      projectList: [],
      selectSiteIds: [],
      siteIdsResult: [],
      searchKeyword: '', // 搜索关键词
      currentConfig: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  computed: {
    querySelectSite() {
      let arr = []
      for (let i = 0; i < this.siteList.length; i++) {
        for (let j = 0; j < this.siteIdsResult.length; j++) {
          if (this.siteList[i].id === this.siteIdsResult[j]) {
            arr.push(this.siteList[i])
            break
          }
        }
      }
      return arr;
    },
    siteAndProjectList() {
      return this.siteList.concat(this.projectList)
    },
    // 获取已配置的工地ID列表
    configuredSiteIds() {
      if (!this.configSiteList || this.configSiteList.length === 0) {
        return [];
      }
      return this.configSiteList.map(site => site.id);
    },
    // 过滤后的工地列表（排除已配置的工地）
    filteredSites() {
      let sites = this.siteList;
      
      // 排除已配置的工地
      if (this.configuredSiteIds.length > 0) {
        sites = sites.filter(site => !this.configuredSiteIds.includes(site.id));
      }
      
      // 搜索过滤
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase();
        sites = sites.filter(site => 
          site.siteName && site.siteName.toLowerCase().includes(keyword)
        );
      }
      
      return sites;
    },
    // 过滤后的项目列表（排除所有工地都已配置的项目）
    filteredProjects() {
      let projects = this.projectList;
      
      // 排除所有工地都已配置的项目
      if (this.configuredSiteIds.length > 0) {
        projects = projects.filter(project => {
          // 获取该项目下的所有工地
          const projectSites = this.siteList.filter(site => site.projectId === project.id);
          
          // 如果项目下没有工地，保留该项目
          if (projectSites.length === 0) {
            return true;
          }
          
          // 如果项目下的所有工地都已被配置，则过滤掉该项目
          const allSitesConfigured = projectSites.every(site => 
            this.configuredSiteIds.includes(site.id)
          );
          
          return !allSitesConfigured;
        });
      }
      
      // 搜索过滤
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase();
        projects = projects.filter(project => 
          project.projectName && project.projectName.toLowerCase().includes(keyword)
        );
      }
      
      return projects;
    },
    // 过滤后的所有项目（工地+项目）
    filteredItems() {
      return this.filteredSites.length + this.filteredProjects.length;
    }
  },
  async created() {
    this.resetSearch();
    this.configList = await attendConfigApi.listAll();
    this.siteList = await commonLqApi.querySiteNoPage()
    this.projectList = await commonLqApi.queryProjectNoPage()
  },
  methods: {
    async queryList() {
      const {records, totalCount} = await attendConfigApi.list(this.searchInfo)
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    close() {
      this.selectSiteIds = []
      this.siteIdsResult = []
      this.searchKeyword = ''
    },
    // 判断工地是否被选中
    isSiteSelected(siteId) {
      return this.selectSiteIds.includes(siteId);
    },
    // 判断项目是否被选中
    isProjectSelected(projectId) {
      return this.selectSiteIds.includes(projectId);
    },
    // 切换工地选中状态
    toggleSite(site) {
      const index = this.selectSiteIds.indexOf(site.id);
      if (index > -1) {
        // 取消选中
        this.selectSiteIds.splice(index, 1);
      } else {
        // 选中
        this.selectSiteIds.push(site.id);
      }
      // 更新实际工地ID列表
      this.updateSiteIdsResult();
    },
    // 切换项目选中状态
    toggleProject(project) {
      const index = this.selectSiteIds.indexOf(project.id);
      if (index > -1) {
        // 取消选中
        this.selectSiteIds.splice(index, 1);
      } else {
        // 选中
        this.selectSiteIds.push(project.id);
      }
      // 更新实际工地ID列表
      this.updateSiteIdsResult();
    },
    // 更新实际工地ID列表（处理项目选择转换为工地）
    updateSiteIdsResult() {
      let arr = [];
      // 遍历所有选中的ID
      out: for (let i = 0; i < this.selectSiteIds.length; i++) {
        const selectedId = this.selectSiteIds[i];
        
        // 检查是否是工地ID
        for (let j = 0; j < this.siteList.length; j++) {
          if (selectedId === this.siteList[j].id) {
            // 只添加未配置的工地
            if (!this.configuredSiteIds.includes(this.siteList[j].id)) {
              arr.push(this.siteList[j].id);
            }
            continue out;
          }
        }

        // 检查是否是项目ID
        for (let j = 0; j < this.projectList.length; j++) {
          if (selectedId === this.projectList[j].id) {
            // 添加该项目下的所有未配置的工地
            for (let k = 0; k < this.siteList.length; k++) {
              if (this.projectList[j].id === this.siteList[k].projectId) {
                // 只添加未配置的工地
                if (!this.configuredSiteIds.includes(this.siteList[k].id)) {
                  arr.push(this.siteList[k].id);
                }
              }
            }
            continue out;
          }
        }
      }
      this.siteIdsResult = arr;
    },
    async save() {
      if (!this.currentData.inTimeMax) {
        this.$message.error("请设置上班打卡时间范围！")
        return
      }
      if (!this.currentData.outTimeMax) {
        this.$message.error("请设置下班打卡时间范围！")
        return
      }
      // 如果时间范围有限制，可能需要修改
      // 时间进行变更
      await attendConfigApi.saveSubmit(this.getTargetData())
      await this.queryList()
      this.showEdit = false;
    },
    getTargetData() {
      let data = {...this.currentData};
      // 如果开始时间大于结束时间，比如22:00:00至02:00:00
      if (data.inTimeMin > data.inTimeMax) {
        data.inTimeMin = "-" + data.inTimeMin;
      }
      if (data.outTimeMin > data.outTimeMax) {
        data.outTimeMax = "+" + data.outTimeMax;
      }
      return data;
    },
    toEdit(row) {
      this.showEdit = true;
      // 时间格式变更
      this.currentData = {
        ...row,
        inTimeMin: row.inTimeMin ? row.inTimeMin.replace("-", "").replace("+", "") : "",
        inTimeMax: row.inTimeMax ? row.inTimeMax.replace("-", "").replace("+", "") : "",
        outTimeMin: row.outTimeMin ? row.outTimeMin.replace("-", "").replace("+", "") : "",
        outTimeMax: row.outTimeMax ? row.outTimeMax.replace("-", "").replace("+", "") : ""
      };
    },
    async deleteRow(id) {
      await attendConfigApi.delete(id)
      await this.queryList()
    },
    async toSet(config) {
      // this.currentConfigId = configId;
      // this.configSiteList = await attendConfigApi.queryClassmateListByConfigId(configId);
      // this.showSet = true;
      this.currentConfig = config;
      this.$nextTick().then(() => {
        this.$refs.settingClassmate.toShowAdd();
      })
    },
    toEditSiteAttendConfig(siteId) {
      if (!siteId) {
        this.$message.error("该行无数据！")
        return
      }
      this.currentSiteId = siteId;
      this.showSelectConfig = true;
    },
    async saveSiteConfig() {
      await attendConfigApi.setSiteAttendanceConfig([this.currentSiteId], this.currentConfigId2)
      this.configSiteList = await attendConfigApi.querySiteListByConfigId(this.currentConfigId);
      this.currentSiteId = ''
      this.$message.success("保存成功")
      this.showSelectConfig = false;
    },
    async saveSiteConfig2(){
      await attendConfigApi.setSiteAttendanceConfig(this.siteIdsResult, this.currentConfigId)
      this.configSiteList = await attendConfigApi.querySiteListByConfigId(this.currentConfigId);
      this.$message.success("保存成功")
      this.showSelectSite = false;
    },
    changeSite(data) {
      // 保留这个方法以兼容旧代码，但实际使用 updateSiteIdsResult
      this.selectSiteIds = data;
      this.updateSiteIdsResult();
    },
    goToWarnConfig() {
      this.router.push('/laborers/attendance-warn-config');
    },
  }
};
</script>

<style lang="scss" scoped>
.dialog-content {
  padding: 10px 0;
  
  .dialog-header-action {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
  }
  
  .form-section {
    margin-bottom: 24px;
    
    .form-label {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
      font-weight: 500;
      color: #303133;
      font-size: 14px;
      
      .required-mark {
        color: #f56c6c;
      }
    }
  }
  
  // 工地列表样式
  .site-list {
    max-height: 500px;
    overflow-y: auto;
    
    .site-card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      margin-bottom: 12px;
      background: #f5f7fa;
      border-radius: 8px;
      border: 1px solid #e4e7ed;
      transition: all 0.3s;
      
      &:hover {
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
      
      .site-info {
        flex: 1;
        
        .site-name {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 8px;
          font-size: 15px;
          font-weight: 500;
          color: #303133;
          
          .el-icon {
            color: #409eff;
            font-size: 18px;
          }
        }
        
        .site-leader {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          color: #909399;
          
          .el-icon {
            font-size: 14px;
          }
        }
      }
      
      .site-actions {
        display: flex;
        gap: 8px;
      }
    }
  }
  
  // 预览区域样式
  .preview-section {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #e4e7ed;
    
    .preview-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
      font-weight: 500;
      color: #303133;
      font-size: 14px;
      
      .el-icon {
        color: #409eff;
        font-size: 16px;
      }
    }
    
    .preview-list {
      max-height: 300px;
      overflow-y: auto;
      
      .preview-card {
        padding: 12px 16px;
        margin-bottom: 8px;
        background: #f0f9ff;
        border-radius: 6px;
        border: 1px solid #b3d8ff;
        
        .preview-info {
          .preview-name {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 6px;
            font-size: 14px;
            font-weight: 500;
            color: #303133;
            
            .el-icon {
              color: #409eff;
              font-size: 16px;
            }
          }
          
          .preview-leader {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 12px;
            color: #909399;
            padding-left: 24px;
            
            .el-icon {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  
  // 选项样式
  .option-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .config-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    
    .config-time {
      font-size: 12px;
      color: #909399;
      margin-left: 12px;
    }
  }
}

// 选择工地弹窗样式
:deep(.select-site-dialog-wrapper) {
  .el-dialog__body {
    padding: 20px;
    overflow: hidden; // 防止dialog整体滚动
  }
}

.select-site-dialog {
  display: flex;
  flex-direction: column;
  height: 70vh;
  min-height: 500px;
  max-height: 700px;
  
  .search-section {
    flex-shrink: 0;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebeef5;
  }
  
  .content-layout {
    flex: 1;
    display: flex;
    gap: 24px;
    min-height: 0; // 重要：允许flex子元素收缩
    overflow: hidden;
    
    .list-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 0;
      border-right: 1px solid #ebeef5;
      padding-right: 24px;
      
      .section-header {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 2px solid #ebeef5;
        
        .header-left {
          display: flex;
          align-items: center;
          gap: 8px;
          
          .el-icon {
            color: #409eff;
            font-size: 18px;
          }
        }
        
        .section-title {
          font-weight: 600;
          font-size: 16px;
          color: #303133;
        }
        
        .section-count {
          font-size: 13px;
          color: #909399;
          background: #f5f7fa;
          padding: 4px 10px;
          border-radius: 12px;
        }
      }
      
      .items-scroll-container {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 8px;
        
        .items-list {
          .items-group {
            margin-bottom: 32px;
            position: relative;
            
            // 确保分组之间有足够间距，避免被覆盖
            &:last-child {
              margin-bottom: 0;
            }
            
            .group-title {
              display: flex;
              align-items: center;
              gap: 8px;
              margin-bottom: 16px;
              font-weight: 500;
              font-size: 14px;
              color: #606266;
              padding: 10px 14px;
              background: linear-gradient(135deg, #f5f7fa 0%, #f0f2f5 100%);
              border-radius: 8px;
              border-left: 3px solid #409eff;
              position: relative;
              z-index: 10; // 确保标题在卡片之上
              
              .el-icon {
                color: #409eff;
                font-size: 16px;
              }
            }
            
            // 网格布局容器
            .items-grid {
              display: grid;
              grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
              gap: 12px;
              position: relative;
              z-index: 1;
            }
            
            .item-card {
              padding: 14px;
              background: #ffffff;
              border: 1.5px solid #e4e7ed;
              border-radius: 10px;
              cursor: pointer;
              transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
              min-height: 120px; // 设置最小高度，确保卡片高度一致
              display: flex;
              flex-direction: column;
              position: relative;
              overflow: hidden;
              
              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 3px;
                background: transparent;
                transition: all 0.25s;
              }
              
              &:hover {
                border-color: #b3d8ff;
                background: linear-gradient(135deg, #f0f9ff 0%, #ecf5ff 100%);
                transform: translateY(-3px);
                box-shadow: 0 6px 16px rgba(64, 158, 255, 0.12);
                
                &::before {
                  background: linear-gradient(90deg, #409eff, #66b1ff);
                }
              }
              
              &.selected {
                border-color: #409eff;
                background: linear-gradient(135deg, #e6f4ff 0%, #d6ebff 100%);
                box-shadow: 0 4px 12px rgba(64, 158, 255, 0.25);
                
                &::before {
                  background: linear-gradient(90deg, #409eff, #66b1ff);
                }
              }
              
              .item-content {
                display: flex;
                flex-direction: column;
                gap: 10px;
                height: 100%;
                
                .item-checkbox {
                  flex-shrink: 0;
                  align-self: flex-start;
                }
                
                .item-info {
                  flex: 1;
                  min-width: 0;
                  
                  .item-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #303133;
                    margin-bottom: 8px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-height: 1.5;
                    min-height: 42px;
                  }
                  
                  .item-detail {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 12px;
                    color: #909399;
                    padding: 4px 0;
                    
                    .el-icon {
                      font-size: 13px;
                      color: #67c23a;
                    }
                  }
                }
                
                // 标签放在底部
                .el-tag {
                  align-self: flex-start;
                  margin-top: auto;
                  border: none;
                  font-weight: 500;
                }
              }
            }
          }
        }
      }
      
      .empty-container {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 200px;
      }
    }
    
    .preview-section {
      flex: 0 0 280px;
      display: flex;
      flex-direction: column;
      min-width: 0;
      
      .section-header {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 2px solid #ebeef5;
        
        .header-left {
          display: flex;
          align-items: center;
          gap: 8px;
          
          .el-icon {
            color: #409eff;
            font-size: 18px;
          }
        }
        
        .section-title {
          font-weight: 600;
          font-size: 16px;
          color: #303133;
        }
        
        .section-count {
          font-size: 13px;
          color: #909399;
          background: #f5f7fa;
          padding: 4px 10px;
          border-radius: 12px;
        }
      }
      
      .preview-scroll-container {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 8px;
        
        .preview-list {
          .preview-card {
            padding: 12px 14px;
            margin-bottom: 10px;
            background: linear-gradient(135deg, #f0f9ff 0%, #e6f4ff 100%);
            border-radius: 8px;
            border: 1px solid #b3d8ff;
            transition: all 0.2s;
            
            &:hover {
              transform: translateX(2px);
              box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
            }
            
            .preview-info {
              .preview-name {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 8px;
                font-size: 14px;
                font-weight: 600;
                color: #303133;
                
                .el-icon {
                  color: #409eff;
                  font-size: 16px;
                }
              }
              
              .preview-leader {
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 12px;
                color: #606266;
                padding-left: 24px;
                
                .el-icon {
                  font-size: 12px;
                  color: #67c23a;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 统一滚动条样式
.items-scroll-container,
.preview-scroll-container {
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
    transition: background 0.2s;
    
    &:hover {
      background: #909399;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}
.time-limit-container{
  display: flex;
  justify-content: space-between;
  .time-limit{
    width: 48%;
  }
}

</style>